export const properties = [
  { id: 'kentucky', name: 'The Overhang', short: 'TO', timezone: 'America/New_York', status: 'active' },
];

export const quickLinks = [
  { id: 'altus-admin', name: 'Altus Admin', mark: 'A', url: 'https://admin.altusretreats.net' },
  { id: 'hospitable', name: 'Hospitable', mark: 'H', url: 'https://my.hospitable.com' },
  { id: 'pricelabs', name: 'PriceLabs', mark: 'P', url: 'https://app.pricelabs.co' },
  { id: 'airbnb', name: 'Airbnb', mark: 'A', url: 'https://www.airbnb.com/hosting' },
  { id: 'starlink', name: 'Starlink', mark: 'S', url: 'https://www.starlink.com/account' },
  { id: 'hostory', name: 'Hostory', mark: 'H', url: 'https://hostory.app' },
  { id: 'stayfi', name: 'StayFi', mark: 'S', url: 'https://app.stayfi.com' },
];

export const snapshot = {
  occupancy: 0,
  arrivals: [],
  departures: [],
  comingNext: [],
  turnovers: [],
  communications: [],
  bookingPulse: { reservations: 0, bookedNights: 0, hostRevenue: 0, averageDailyRate: 0, currency: 'USD', channelMix: {} },
  weather: null,
  alerts: [],
  calendarReservations: [],
};
